import { render, staticRenderFns } from "./PolicyCancellation.vue?vue&type=template&id=7495a76e&scoped=true&"
import script from "./PolicyCancellation.vue?vue&type=script&lang=ts&"
export * from "./PolicyCancellation.vue?vue&type=script&lang=ts&"
import style0 from "./PolicyCancellation.vue?vue&type=style&index=0&id=7495a76e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7495a76e",
  null
  
)

export default component.exports